// @flow
import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import getEmailSettings from '../../api/getEmailSettings';
import { ACTIONS } from '../../../notificationSettings/constants';

export default function useEmailSettings(token: string) {
    const [isLoading, setIsLoading] = useState(true);
    const [emailAddress, setEmailAddress] = useState();
    const dispatch = useDispatch();

    const notificationSettings = useSelector((state: {}) => {
        return state.notificationSettings;
    });

    useEffect(
        () => {
            const fetchEmailSettingsData = async () => {
                const response = await getEmailSettings(token);
                if (response.settings && response.settings.length > 0) {
                    setEmailAddress(response.email);
                    dispatch({
                        type: ACTIONS.NOTIFICATION_SETTINGS_LOADED,
                        settings: response.settings
                    });
                }

                setTimeout(() => {
                    setIsLoading(false);
                }, 0);
            };
            fetchEmailSettingsData();
        },
        [dispatch, setIsLoading, token]
    );

    return {
        isLoading,
        notificationSettings,
        emailAddress
    };
}



// WEBPACK FOOTER //
// ./src/v5/emailSettings/components/hooks/useEmailSettings.js